import React from 'react';
import {
  formErrorTextClassName,
  formHelpTextClassName,
  formLabelClassName,
  formTextAreaClassName,
} from './formFieldStyles';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helpText?: string;
  required?: boolean;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, error, helpText, required, className, id, ...props }, ref) => {
    const inputId = id || `textarea-${Math.random().toString(36).slice(2)}`;

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className={`${formLabelClassName} mb-1.5`}>
            {label}
            {required && <span className="ms-1 text-[#A32D2D]">*</span>}
          </label>
        )}

        <textarea
          ref={ref}
          id={inputId}
          className={`${formTextAreaClassName} ${error ? 'border-[#A32D2D] focus:border-[#A32D2D] focus:ring-[rgba(163,45,45,0.12)]' : ''} ${className || ''}`}
          aria-invalid={!!error}
          aria-describedby={error ? `${inputId}-error` : helpText ? `${inputId}-help` : undefined}
          {...props}
        />

        {error && (
          <p id={`${inputId}-error`} className={formErrorTextClassName}>
            {error}
          </p>
        )}

        {helpText && !error && (
          <p id={`${inputId}-help`} className={formHelpTextClassName}>
            {helpText}
          </p>
        )}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';
